<template>
  <div class="section-header text-center mb-5" :class="customClass">
    <h2 class="section-title" v-if="title">{{ title }}</h2>
    <h3 class="section-subtitle" v-if="subtitle">{{ subtitle }}</h3>
    <p class="section-description" v-if="description">{{ description }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
// Importar variables de color centralizadas
@import '../styles/variables';

.section-header {
  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: $landing-primary-color;
    margin-bottom: 1.5rem;
    line-height: 1.2;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
  
  .section-subtitle {
    font-size: 2.2rem;
    font-weight: 600;
    color: #2D4A4D;
    margin-bottom: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 1.8rem;
    }
  }
  
  .section-description {
    font-size: 1.4rem;
    color: #2D4A4D;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.7;
    font-weight: 500;
    
    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
}
</style>
